import React, { useEffect, useRef, useState } from 'react'
import './giftFilters.css'

const GiftFilters = ({ options, selected, setSelected }) => {

    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // Ferme la liste au clic en dehors ou avec Échap
    useEffect(() => {
        if (!open) return;
        const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) };
        const handleKey = (e) => { if (e.key === 'Escape') setOpen(false) };
        document.addEventListener('mousedown', handleClick);
        document.addEventListener('keydown', handleKey);
        return () => {
            document.removeEventListener('mousedown', handleClick);
            document.removeEventListener('keydown', handleKey);
        }
    }, [open])

    // Au moins un type doit rester coché
    const toggle = (option) => {
        if (!selected.includes(option)) setSelected(options.filter((elt) => elt === option || selected.includes(elt)));
        else if (selected.length > 1) setSelected(selected.filter((elt) => elt !== option));
    }

    const allSelected = options.length > 0 && selected.length === options.length;
    const summary = allSelected ? 'Tous' : selected.length === 1 ? selected[0] : `${selected.length} sélectionnés`;

    return (
        <div className='giftFilterComponent' ref={ref}>
            <label id='gift-filter-label'>Types</label>
            <button
                type='button'
                className='giftFilter_button'
                aria-haspopup='listbox'
                aria-expanded={open}
                aria-labelledby='gift-filter-label'
                onClick={() => setOpen(!open)}
            >
                <span>{summary}</span>
                <span className={`giftFilter_arrow ${open ? 'giftFilter_arrow-open' : ''}`}>▾</span>
            </button>
            {
                open && (
                    <div className='giftFilter_menu' role='listbox' aria-multiselectable='true'>
                        {
                            !allSelected && (
                                <button type='button' className='giftFilter_selectAll' onClick={() => setSelected(options)}>
                                    Tout sélectionner
                                </button>
                            )
                        }
                        {
                            options.map((option) => (
                                <label key={option} className='giftFilter_option'>
                                    <input
                                        type='checkbox'
                                        checked={selected.includes(option)}
                                        onChange={() => toggle(option)}
                                    />
                                    {option}
                                </label>
                            ))
                        }
                    </div>
                )
            }
        </div>
    )
}

export default GiftFilters
